/**
 * Tab name constants for fund details navigation
 * Used for query parameters when navigating between tabs
 */
export const FUND_DETAILS_TABS = {
  MAIN_DETAILS: 'main-details',
  FINANCIALS: 'financials',
  OFFERING: 'offering',
  UNIT_MANAGEMENT: 'unit-management',
  INVESTMENTS: 'investments',
  REPORTS: 'reports',
} as const;

/**
 * Tab name constants for fund creation form navigation
 */
export const FUND_CREATION_TABS = {
  GENERAL_DATA: 'general-data',
  MANAGEMENT_TEAM: 'management-team',
  FINANCIAL_DATA: 'financial-data',
  ATTACHMENTS: 'attachments',
} as const;

/**
 * Array of fund details tab names in order
 * Used for tab components that need sequential access
 */
export const FUND_DETAILS_TAB_LIST: string[] = [
  FUND_DETAILS_TABS.MAIN_DETAILS,
  FUND_DETAILS_TABS.FINANCIALS,
  FUND_DETAILS_TABS.OFFERING,
  FUND_DETAILS_TABS.UNIT_MANAGEMENT,
  FUND_DETAILS_TABS.INVESTMENTS,
  FUND_DETAILS_TABS.REPORTS,
];

/**
 * Array of fund creation tab names in order
 * Used for tab components that need sequential access
 */
export const FUND_CREATION_TAB_LIST: string[] = [
  FUND_CREATION_TABS.GENERAL_DATA,
  FUND_CREATION_TABS.MANAGEMENT_TEAM,
  FUND_CREATION_TABS.FINANCIAL_DATA,
  FUND_CREATION_TABS.ATTACHMENTS,
];
